import { Component, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { MustMatch } from './must-match.validator';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { UserService } from 'src/app/service/user.service';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
// import { User } from 'src/app/models/user';
import { questionDetails, User } from 'src/app/models/user';
import { NgxSpinnerService } from 'ngx-spinner';
@Component({
  selector: 'app-password-creation',
  templateUrl: './password-creation.component.html',
  styleUrls: ['./password-creation.component.css']
})

export class PasswordCreationComponent implements OnInit {
  passwordCreationForm!: UntypedFormGroup;
  isSubmitted = false;
  loginName:any;
  reqJson:any;
  userDetails: User = new User;
  questionPolicyLength : any
  showDetails = false;
  questionToRetain : string[] = [];
  globalStore : any
  secQuesResponse!: questionDetails[];
  secQuesValues: any = [];
  passwordPolicyMap : any
  options : any
  meetingId!:any;
  isGuestUser:any;
  onStrengthChanged(strength: any) {
   
  }
  toggler(){
    this.showDetails = true
  }
  questionArrayStructure = [
    {
    "qusCode" :"doyoulikereadingbooks" ,
    "qusDesc" : "Do you like Reading Books"
    },
    {
    "qusCode" :"faouritesport" ,
    "qusDesc" : "Faourite sport"
    },
    {
    "qusCode" :"favouritecolour",
    "qusDesc" : "Favourite Colour"
    },
    {
    "qusCode" :"favouritefruit",
    "qusDesc" : "Favourite Fruit"
    },
    {
    "qusCode" :"favouritegame" ,
    "qusDesc" : "Favourite Game"
    },
    {
    "qusCode" :"favouritesport",
    "qusDesc" : "Favourite sport"
    },
    {
    "qusCode" : "inwhatcitywereyouborn" ,
    "qusDesc" : "In what city were you born?"
    }
    ]

  private readonly notifier!: NotifierService;
  constructor(private router : Router, private activatedroute: ActivatedRoute,private notifierService: NotifierService,private formBuilder: UntypedFormBuilder,private userService:UserService,private spinner: NgxSpinnerService) { 
    this.notifier = notifierService;

    this.activatedroute.queryParams.subscribe(
      params => {
        this.loginName=params['userName'];
        this.meetingId = params['meetingId'];
        this.isGuestUser = params['isGuest'];
        if(this.isGuestUser!=undefined && this.meetingId!=undefined){
          this.reqJson={"loginName":params['userName'],"orgCode":"free_orgcode","newPasswordFlag":1,"isGuest":this.isGuestUser,"meetingId":this.meetingId};
        }else{
          this.reqJson={"loginName":params['userName'],"orgCode":"free_orgcode","newPasswordFlag":1};
        }

        //this.reqJson.loginName = params['userName'];
        //this.reqJson.orgCode="free_orgcode";
  
      });
      this.spinner.show()
      this.userService.fetchPasswordDetails(this.reqJson).subscribe((data: any) => {
       
       this.userDetails = data.body;
        //this.userDetails.pwdPolicyMap = data['pwdPolicyMap'];
        if(this.userDetails.userLoginFlag!=undefined && this.userDetails.userLoginFlag=="0"){
          this.notifier.show({
            type: 'error',
            message: 'Password Already Created'
          });
          this.router.navigate(['']);  
        }
        this.secQuesResponse = this.userDetails.secQuesList;
        this.passwordPolicyMap = this.userDetails.pwdPolicyMap
        this.meetingId=this.userDetails.meetingId;
        
     
        
        this.questionPolicyLength = Number(this.userDetails.noOfSecQuesConf);
   
        for(let i = 1; i < this.questionPolicyLength; i++){
          let fg = this.createEmpFormGroup();
          this.employees.push(fg);
        }
        this.spinner.hide();
      });
      
  }

  trigger(){
    this.options = {
      'placement': 'right',
      'password': {
          'type': "range",
          'min' : 10,
          'max' : 15
      },
      'shadow': false,
      'offset': 15,
  }
  }

  ngOnInit(): void {

    this.passwordCreationForm = this.formBuilder.group({
      // title: ['', Validators.required],
      //validator for password with lower case, uppercase, special charters and numbers and minimum length should be 6 
      password : ['',[Validators.required, Validators.pattern('((?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,30})'), Validators.minLength(6)]],
      confirmPassword : ['',Validators.required],
      questionContainer: this.formBuilder.array(
				[this.createEmpFormGroup()],
				[Validators.required, Validators.maxLength(5)]),
  },{
    validator: MustMatch('password', 'confirmPassword')
  })
  if(this.questionPolicyLength){
    this.spinner.hide()
  }
}

  get employees(): UntypedFormArray {
    return this.passwordCreationForm.get('questionContainer') as UntypedFormArray;
  } 

  addEmployee() {
	}

  createEmpFormGroup() {
		return this.formBuilder.group({
			questions: ['', [Validators.required]],
			answers: ['', [Validators.required]],
		})
	}

  changeTracker(event : any, id : any) {
    
    if(this.questionToRetain.length == 0){
      this.questionToRetain.push(event.value)
      
    }
    else if((this.questionToRetain[id] == event.value) == false){
      
      this.questionToRetain[id] = event.value
      // this.questionToRetain.push(event.value)
      
    }
    
  }

  disabledSelectedItems(event : any){
    let checker;
    if(this.questionToRetain.length){
      for(let i = 0; i < this.questionToRetain.length; i++){
        if(this.questionToRetain[i] == event){
          checker = true
          // return true;
        }
      }
    }
    return checker;
  }

  checkUserSelection(value : any){
    
    return true
    
  }

  get f() { 
    return this.passwordCreationForm.controls;
  }
  public passwordCreationError = (controlName: string, errorName: string) => {
    return this.passwordCreationForm.controls[controlName].hasError(errorName)
  }
  onSubmit() {
    this.spinner.show();
    this.isSubmitted = true;
    
    this.secQuesValues= [];
    for (let i = 0; i < this.employees.length; i++) {
      
      var eachQuesJson = {
        "quesCode": this.employees.at(i).get('questions')?.value,
        "quesAnswer": this.employees.at(i).get('answers')?.value
      };
      this.secQuesValues.push(eachQuesJson);
    }
    if(this.isGuestUser==undefined){
      this.reqJson={"loginName":this.loginName,"password":this.passwordCreationForm.get('password')?.value,"secQuesString":JSON.stringify(this.secQuesValues)};
    }else{
      this.reqJson={"loginName":this.loginName,"password":this.passwordCreationForm.get('password')?.value,"secQuesString":JSON.stringify(this.secQuesValues),"isGuest":this.isGuestUser};
    }

    
    // stop here if form is invalid
    if (this.passwordCreationForm.invalid) {
      this.isSubmitted = false;
      this.notifier.show({
        type: 'error',
        message: 'Answer all security questions'
      });
      this.spinner.hide();
        return;
    }
    
    this.userService.updatePasswordDetails(this.reqJson).subscribe((data: any) => {
      this.userDetails = data.body;
      
      if(this.userDetails.errorMessage!=undefined && this.userDetails.errorMessage!==null && this.userDetails.errorMessage!="" ){
          this.notifier.show({
            type: 'error',
            message: this.userDetails.errorMessage
          });
      }else{
        this.notifier.show({
          type: 'success',
          message: 'Account Activated Successfully'
        });
        
        if(this.meetingId!=undefined){
          this.spinner.hide();
          this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : this.meetingId }) }, skipLocationChange: true, replaceUrl: false });
        }else{
          this.spinner.hide();
          this.router.navigate(['login']);
        }
      }
    });
    
    // display form values on success
    // alert('SUCCESS!! :-)\n\n' + JSON.stringify(this.signUpForm.value, null, 4));
}

}
function data(data: any, any: any, arg2: {}) {
  throw new Error('Function not implemented.');
}
